import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { BannerDetails } from "../../banners.types";
import { requestGetBanner } from "./getBanner.request";

const useBanner = (
  bannerId?: string,
  options?: QueryOptions<BannerDetails, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["banner", bannerId],
    queryFn: async () => await requestGetBanner(bannerId),
    enabled: !!bannerId,
    ...options
  });

  return { banner: data, ...rest };
};

export default useBanner;
